import { api } from "./axios";
import { trackStream, untrackStream } from "../lib/stopBeacon";
import type { Subtype } from "../types";

export interface StartStreamResponse {
  stream_id: string;
  stream_name: string;
  ws_url: string;
  webrtc_url: string;
}

export async function startStream(
  device_id: number,
  channel: number,
  subtype: Subtype,
  opts: { transcode?: boolean } = {},
): Promise<StartStreamResponse> {
  const r = await api.post("/streams/start", {
    device_id,
    channel,
    subtype,
    ...(opts.transcode ? { transcode: true } : {}),
  });
  trackStream(r.data.stream_id);
  return r.data;
}

export async function stopStream(stream_id: string): Promise<void> {
  // untrack recien tras confirmar el stop: si este POST falla, el beacon de
  // pagehide lo reintenta al descargar la pagina (el backend es idempotente).
  await api.post("/streams/stop", { stream_id });
  untrackStream(stream_id);
}

export async function swapSubtype(stream_id: string, new_subtype: Subtype): Promise<StartStreamResponse> {
  const r = await api.post("/streams/swap-subtype", { stream_id, new_subtype });
  // el backend detiene el stream viejo y devuelve uno nuevo
  untrackStream(stream_id);
  trackStream(r.data.stream_id);
  return r.data;
}
